<div id="dashboard-container">
  <div class="page-header">
    <app-toolbar-options  backlink="/employer-details">
      <div class="d-flex flex-column" slot="start">
        <div class="page-title">Employer Edit</div>
      </div>

    </app-toolbar-options>
  </div>
  <div class="page-content" appanimatecss>

    <app-component-wrapper class="mt w-100" icon="">
      <div class="d-flex flex-column" slot="start">
        <app-employer-edit></app-employer-edit>
      </div>
    </app-component-wrapper>


  </div>
</div>
